/**
 * 본문에서 해시태그를 뽑는다.
 *
 * `#` 를 붙인 채로 돌려준다(`"#뷰티"`). 소비처가 표시용으로 그대로 쓰기 때문이다.
 */

/**
 * 텍스트에서 해시태그를 추출
 * @param {string} text - 해시태그를 추출할 텍스트
 * @returns {Array<string>} 추출된 해시태그 배열
 * 
 * @example
 * extractHashtags("#뷰티 #화장품 추천합니다") // ["#뷰티", "#화장품"]
 */
export const extractHashtags = (text: unknown): string[] => {
  if (!text || typeof text !== 'string') return [];

  // 모든 유니코드 문자를 포함하는 해시태그 정규식
  // #으로 시작하고 공백이나 특수문자가 아닌 문자들로 구성
  // 더 포괄적인 패턴: #으로 시작하고 공백, 구두점, 특수문자가 아닌 모든 문자
  const hashtagRegex = /#[^\s#@.,!?;:()[\]{}'"]+/g;
  const matches = text.match(hashtagRegex) || [];


  return matches;
};

/**
 * 여러 텍스트에서 중복을 제거한 해시태그 배열 생성
 * @param {...string} texts - 해시태그를 추출할 텍스트들
 * @returns {Array<string>} 중복 제거된 해시태그 배열
 * 
 * @example
 * extractUniqueHashtags("#뷰티 제목", "#화장품 #뷰티 내용") // ["#뷰티", "#화장품"]
 */
export const extractUniqueHashtags = (...texts: unknown[]): string[] => {
  const allHashtags = texts.flatMap(text => extractHashtags(text));
  return [...new Set(allHashtags)];
};
